export default __webpack_public_path__ + "static/media/2017 LV SHOW BOOTH_PT-01.3f16d238.jpg";